import React, { useRef, useState, useEffect } from 'react';
import VoiceAssistantUI from './audio_video/VoiceAssistantUI';
import { useVoice } from '../Context/VoiceContext';

const GlobalVoiceUI = () => {
  const { 
    showVoicePopup, 
    setShowVoicePopup, 
    voiceAnimationState, 
    voicePosition, 
    setVoicePosition,
    startRecording,
    stopRecording
  } = useVoice();

  const [dragging, setDragging] = useState(false);
  const [rel, setRel] = useState({ x: 0, y: 0 });
  const popupRef = useRef(null);

  const onMouseDown = (e) => {
    if (e.button !== 0) return;
    const rect = popupRef.current.getBoundingClientRect();
    setDragging(true);
    setRel({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
    e.stopPropagation();
    e.preventDefault();
  };

  const onMouseUp = () => setDragging(false);

  const onMouseMove = (e) => {
    if (!dragging) return;
    const newX = e.clientX - rel.x;
    const newY = e.clientY - rel.y;

    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const popupWidth = popupRef.current ? popupRef.current.offsetWidth : 320;
    const popupHeight = popupRef.current ? popupRef.current.offsetHeight : 200;

    const padding = 20;
    const constrainedX = Math.max(padding, Math.min(newX, viewportWidth - popupWidth - padding));
    const constrainedY = Math.max(padding, Math.min(newY, viewportHeight - popupHeight - padding));

    setVoicePosition({ x: constrainedX, y: constrainedY });
    e.stopPropagation();
    e.preventDefault();
  };

  useEffect(() => {
    if (dragging) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    } else {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    }
    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [dragging]);

  useEffect(() => {
    if (showVoicePopup) {
      startRecording();
    } else {
      stopRecording();
    }
  }, [showVoicePopup]);

  if (!showVoicePopup) return null;

  return (
    <div
      ref={popupRef}
      className="voice-floating-popup"
      style={{
        left: voicePosition.x,
        top: voicePosition.y,
        position: 'fixed',
        zIndex: 9999
      }}
      onMouseDown={onMouseDown}
    >
      <VoiceAssistantUI
        state={voiceAnimationState}
        onClose={() => setShowVoicePopup(false)}
      />
    </div>
  );
};

export default GlobalVoiceUI;
